<!-- UI/UX Note: classes names and styles are only for testing purposes. Please make any change you want  -->

<template>
	<div class="section-header">
		<div class="section-header__head">
			<div class="section-header__left-section" data-test="left-section">
				<slot name="left">
					<h5>{{ title }}</h5>
					<p>{{ subTitle }}</p>
				</slot>
			</div>
			<div
				class="section-header__right-section"
				data-test="right-section"
				v-if="$slots['right']"
			>
				<slot name="right" />
			</div>
		</div>
		<div
			v-show="open"
			class="section-header__content"
			data-test="contentSection"
		>
			<slot name="content" />
		</div>
		<Button
			:btnClick="() => (open = !open)"
			v-if="isExpandable"
			className="btn--icon-only"
			:iconClassName="iconClass"
			:iconBeforeLabel="true"
			data-test="expandBtn"
		/>
	</div>
</template>

<script>
import Button from '@/components/forms/button/button';

export default {
	name: 'SectionContainer',
	components: {
		Button
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		subTitle: {
			type: String,
			default: ''
		},
		isExpandable: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			open: true
		};
	},
	computed: {
		iconClass() {
			return this.open ? 'icon-arrow-up' : 'icon-arrow-down';
		}
	}
};
</script>

<style lang="scss" scoped>
.section-header {
	&__head {
		display: flex;
		justify-content: space-between;
		gap: $gutter-xl;
		align-items: center;
		padding-bottom: $padding-lg;
		border-bottom: 1px solid $neutral-3;
		margin-bottom: $gutter-lg;
	}
}
</style>
